if (!customElements.get('gpt-cd-life-carousel')) {
  customElements.define('gpt-cd-life-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.viewport = this.querySelector('[data-life-viewport]');
      this.slides = [...this.querySelectorAll('[data-life-slide]')];
      this.previous = this.querySelector('[data-life-previous]');
      this.next = this.querySelector('[data-life-next]');
      if (!this.viewport || this.slides.length === 0) return;

      this.index = Math.min(Math.max(Number(this.dataset.start || 1) - 1, 0), this.slides.length - 1);
      this.previous?.addEventListener('click', () => this.go(this.index - 1));
      this.next?.addEventListener('click', () => this.go(this.index + 1));
      this.viewport.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.go(this.index - 1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.go(this.index + 1);
        }
      });
      this.viewport.addEventListener('scroll', () => {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => this.updateFromScroll());
      }, { passive: true });
      this.addEventListener('shopify:block:select', event => {
        const selected = event.target.closest('[data-life-slide]');
        const index = this.slides.indexOf(selected);
        if (index >= 0) this.go(index, false);
      });
      requestAnimationFrame(() => this.go(this.index, false));
    }

    go(index, smooth = true) {
      this.index = Math.min(Math.max(index, 0), this.slides.length - 1);
      const slide = this.slides[this.index];
      const left = slide.offsetLeft - (this.viewport.clientWidth - slide.offsetWidth) / 2;
      this.viewport.scrollTo({ left, behavior: smooth ? 'smooth' : 'auto' });
      this.updateState();
    }

    updateFromScroll() {
      const center = this.viewport.scrollLeft + this.viewport.clientWidth / 2;
      let nearest = 0;
      let distance = Infinity;
      this.slides.forEach((slide, index) => {
        const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
        const nextDistance = Math.abs(slideCenter - center);
        if (nextDistance < distance) {
          nearest = index;
          distance = nextDistance;
        }
      });
      if (nearest !== this.index) {
        this.index = nearest;
        this.updateState();
      }
    }

    updateState() {
      this.slides.forEach((slide, index) => {
        if (index === this.index) slide.setAttribute('aria-current', 'true');
        else slide.removeAttribute('aria-current');
      });
      if (this.previous) this.previous.disabled = this.index === 0;
      if (this.next) this.next.disabled = this.index === this.slides.length - 1;
    }
  });
}
